"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleIdentifierValidator = void 0;
class VehicleIdentifierValidator {
    static isValid(vehicleId) {
        return VehicleIdentifierValidator.isValidVin(vehicleId)
            || VehicleIdentifierValidator.isValidCommissionNumber(vehicleId)
            || VehicleIdentifierValidator.isValidCommissionNumberWithYear(vehicleId)
            || VehicleIdentifierValidator.isValidInventoryNumber(vehicleId);
    }
    static isValidVin(vehicleId) {
        return !!vehicleId && VehicleIdentifierValidator.REGEX_VIN.test(vehicleId);
    }
    static isValidCommissionNumber(vehicleId) {
        return VehicleIdentifierValidator.REGEX_COMMISSION_NUMBER.test(vehicleId);
    }
    static isValidCommissionNumberWithYear(vehicleId) {
        return VehicleIdentifierValidator.REGEX_COMMISSION_NUMBER_WITH_YEAR.test(vehicleId);
    }
    static isValidInventoryNumber(vehicleId) {
        return VehicleIdentifierValidator.isValidCommissionNumber(vehicleId.slice(1));
    }
    static isCommercialVehicleVin(vehicleId) {
        return VehicleIdentifierValidator.isValidVin(vehicleId)
            && VehicleIdentifierValidator.COMMERCIAL_VEHICLES_WMI.includes(vehicleId.slice(0, 3));
    }
}
exports.VehicleIdentifierValidator = VehicleIdentifierValidator;
VehicleIdentifierValidator.REGEX_VIN = /^[A-HJ-NPR-Z\d]{13}\d{4}$/;
VehicleIdentifierValidator.REGEX_COMMISSION_NUMBER_WITH_YEAR = /^\d{4}[A-Z0-9]{6}$/;
VehicleIdentifierValidator.REGEX_COMMISSION_NUMBER = /^[A-Z\d]{6}$/;
VehicleIdentifierValidator.COMMERCIAL_VEHICLES_WMI = ['WV1', 'WV2', 'WV3', 'WV4'];
//# sourceMappingURL=VehicleIdentifierValidator.js.map